import { Controller } from "stimulus";

// Instruments a Home Hero carousel slide (ENG-11949) - a real Announcement reports through the same pipeline as top bar/modal, the static fallback slide reports straight to PostHog instead.
export default class extends Controller {
  static values = {
    eventsUrl: String,
    renderToken: String,
    trackingKey: String
  }

  // Splide keeps every slide in the DOM, just hidden - fire only once it's marked "is-active", not on mount.
  connect() {
    const slide = this.element.closest(".splide__slide")
    if (!slide) return this.track("viewed") // not in a carousel (e.g. the sole slide, no hero promo)

    const fireIfActive = () => {
      if (!slide.classList.contains("is-active")) return
      this.track("viewed")
      this.activeObserver.disconnect()
    }

    this.activeObserver = new MutationObserver(fireIfActive)
    this.activeObserver.observe(slide, { attributes: true, attributeFilter: ["class"] })
    fireIfActive()
  }

  disconnect() {
    this.activeObserver?.disconnect()
  }

  trackPrimaryCta() {
    this.track("primary_cta")
  }

  trackSecondaryCta() {
    this.track("secondary_cta")
  }

  track(event) {
    if (this.eventsUrlValue && this.renderTokenValue) return this.trackAnnouncement(event)
    if (this.trackingKeyValue) return this.trackStatic(event)
  }

  trackAnnouncement(event) {
    fetch(this.eventsUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({
        event,
        render_token: this.renderTokenValue,
        page_path: window.location.pathname
      })
    }).catch(() => {})
  }

  trackStatic(event) {
    if (!window.posthog) return

    const eventNames = { viewed: "viewed", primary_cta: "primaryCta_clicked", secondary_cta: "secondaryCta_clicked" }

    window.posthog.capture(`${this.trackingKeyValue}.${eventNames[event] || event}`, { placement: "hero" })
  }
}
